/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserTenantDetails {
    getFixupPrototypeFunction() { return UserTenantDetails.fixupPrototype; }

    static newInstance(model: Partial<UserTenantDetails>): UserTenantDetails {
        let obj = Object.assign(new UserTenantDetails(), model);
        UserTenantDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserTenantDetails>): UserTenantDetails {
        if (!model) return null;
        return UserTenantDetails.newInstance(<UserTenantDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserTenantDetails) {
        if (!obj) return;

        models.UserTenantDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserTenantDetails): boolean {
        Object.setPrototypeOf(obj, UserTenantDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the User. This is an auto generated and unique in the CoreStack system
     */
    user_id: string;

    /**
     * Username is unique in the CoreStack system. User can use this to login to CoreStack portal in addition to email
     */
    username: string;

    /**
     * Current Status of the user - active or inactive. Inactive user cannot login or use AccessKeys
     */
    status: string;

    /**
     * Email of the User. This is unique in the CoreStack system
     */
    email: string;

    /**
     * List of role assignments for the user. The same user can be assigned with different roles in a tenant
     */
    roles: Array<string>;

}
